module.exports = __webpack_public_path__ + "static/media/image-2.02cf5b73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/image-2.jpg
// module id = 279
// module chunks = 0